module.exports = __webpack_public_path__ + "static/dsc-0837-703e9bd7f467dacab65fc476ee8961e9.png";